<template>
	<div class="containerMain">
		<title-bar :topTitle="true" topTitleText="Colegios"/>
		<title-bar v-if="school" :title="school.name"/>
		<div class="col inner" v-if="school && history && history.length > 0">
				<b-card-group deck class="mt-2">
		      <b-card v-if="school.visitClosures">
						<p class="card-text text-center mt-2 mb-2">{{school.visitClosures.name}}</p>
						<p class="card-text text-center mt-2 mb-2">{{school.visitClosures.count}}</p>
						<p class="card-text text-center" v-if="school.visitClosures.lastDate">{{getHumanDate(school.visitClosures.lastDate)}}</p>
						<p class="card-text text-center" v-else>Sin visitas</p>
					</b-card>

					<b-card v-if="school.trainings">
						<p class="card-text text-center mt-2 mb-2">{{school.trainings.name}}</p>
						<p class="card-text text-center mt-2 mb-2">{{school.trainings.count}}</p>
						<p class="card-text text-center" v-if="school.trainings.lastDate">{{getHumanDate(school.trainings.lastDate)}}</p>
						<p class="card-text text-center" v-else>Sin capacitaciones</p>
					</b-card>

					<b-card v-if="school.issues">
						<p class="card-text text-center mt-2 mb-2">{{school.issues.name}}</p>
						<p class="card-text text-center mt-2 mb-2">{{school.issues.count}}</p>
						<p class="card-text text-center" v-if="school.issues.lastDate">{{getHumanDate(school.issues.lastDate)}}</p>
						<p class="card-text text-center" v-else>Sin incidencias</p>
					</b-card>

					<b-card v-if="school.diagnoses">
						<p class="card-text text-center mt-2 mb-2">{{school.diagnoses.name}}</p>
						<p class="card-text text-center mt-2 mb-2">{{school.diagnoses.count}}</p>
						<p class="card-text text-center" v-if="school.diagnoses.lastDate">{{getHumanDate(school.diagnoses.lastDate)}}</p>
						<p class="card-text text-center" v-else>Sin diagnosticos</p>
					</b-card>

					<b-card v-if="school.evaluations">
						<p class="card-text text-center mt-2 mb-2">{{school.evaluations.name}}</p>
						<p class="card-text text-center mt-2 mb-2">{{school.evaluations.count}}</p>
						<p class="card-text text-center" v-if="school.evaluations.lastDate">{{getHumanDate(school.evaluations.lastDate)}}</p>
						<p class="card-text text-center" v-else>Sin evaluaciones</p>
					</b-card>
		  </b-card-group>
			<div class="col between innerRubric sd">
				<b-table responsive style="cursor: pointer;" class="category all" striped hover :items="history" :fields="tableFields" @row-clicked="onRowClick">
					<template slot="date" slot-scope="item">
						{{item.value ? getHumanDate(item.value) : ''}}
					</template>
					<template slot="title" slot-scope="item">
						{{item.value || 'Sin título'}}
					</template>
				</b-table>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';

export default {
	props: ['schoolId'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	data () {
		return {
			tableFields: {
				date: {
					label: 'Fecha',
					sortable: true
				},
				type: {
					label: 'Tipo',
					sortable: true
				},
				title: {
					label: 'Título/Nombre',
					sortable: true
				},
				personName: {
					label: 'Coach',
					sortable: true
				}
			}
		};
	},
	computed: {
		school () {
			if (!this.$store.state.admin.schools) return null;
			let school = this.$store.state.admin.schools.find((school) => (school.schoolId == this.schoolId));
			school.visitClosures = school.synthesisSummary.find((synthesis) => (synthesis.code == 'visitClosure'));
			school.trainings = school.synthesisSummary.find((synthesis) => (synthesis.code == 'training'));
			school.issues = school.synthesisSummary.find((synthesis) => (synthesis.code == 'issue'));
			school.diagnoses = school.synthesisSummary.find((synthesis) => (synthesis.code == 'currentDiagnosis'));
			school.evaluations = school.synthesisSummary.find((synthesis) => (synthesis.code == 'evaluation'));
			return school;
		},
		history () {
			return this.$store.state.admin.schoolHistory;
		}
	},
	methods: {
		getHumanDate (date) {
			return helpers.dateTime.getHumanDate(date);
		},
		onRowClick (item) {
			if (item.code == 'visitClosure') this.$router.push(`/coaching/admin/schools/${this.schoolId}/visit-closure/${item.id}`);
			if (item.code == 'training') this.$router.push(`/coaching/admin/schools/${this.schoolId}/training/${item.id}`);
			if (item.code == 'currentDiagnosis') this.$router.push(`/coaching/admin/schools/${this.schoolId}/diagnostic/${item.id}`);
			if (item.code == 'issue') this.$router.push(`/coaching/admin/schools/${this.schoolId}/issue/${item.id}`);
			if (item.code == 'evaluation') this.$router.push(`/coaching/admin/schools/${this.schoolId}/evaluation/${item.id}`);
			if (item.code == 'indicator') this.$router.push(`/coaching/admin/indicator/${item.id}`);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/admin/SchoolAllSyntheses.vue